import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegionSelector = () => {
  const navigate = useNavigate();

  // Auto-redirect to Ireland
  useEffect(() => {
    navigate('/ie', { replace: true });
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-[#1a5c3a] flex items-center justify-center">
      <div className="text-center text-white">
        <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-body">Redirecting...</p>
      </div>
    </div>
  );
};

export default RegionSelector;
